import { InboxFoldersIndex } from './InboxFoldersIndex'

/**
 * Main Inbox tab: folders list-surface index with PanelRight preview.
 * Replaces legacy split feed+reader layout.
 */
export function InboxPage() {
  return <InboxFoldersIndex />
}
